import { get } from 'lodash';

export const getAssignedPkgState = (state) => state.dvm.assignedpkg || {};

export const getAssignedPkgByAdomOid = (adomOid) => (state) => {
  return get(getAssignedPkgState(state), [adomOid], {});
};
